/* @flow strict */

/* eslint-disable camelcase */
/* eslint-disable max-params */

import * as React from 'react';
import EventPageDetailCustomersContent from './indexContent';
import { Link } from 'react-router-dom';
import { GET } from '/client/src/api';
import { defaultFilterConfig } from './defaultFilterConfig';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';

import './styles.scss';

type PropsType = {
  eventId: number | string,
  subViewTab?: string
};

const items = [
  {
    link: '',
    label: 'Tickets'
  },
  {
    link: 'payments',
    label: 'Payments'
  },
  {
    link: 'questions',
    label: 'Questions'
  },
  {
    link: 'referrals',
    label: 'Referrals'
  },
  {
    link: 'demographics',
    label: 'Demographics'
  }
];

const EventPageDetailCustomers = ({ eventId, subViewTab }: PropsType): React.Element<'div'> => {
  // Trigger to re-render table for do newone request to API
  // Hack for not touch old realisation in API side
  const [counter, _handleTriggerChangeTableContent] = React.useState(0);

  const context = React.useContext(EventDetailContainerContext);

  const [showPaymentModal, handleShowPaymentModal] = React.useState(false);
  const [showPaymentPurchaseModal, handleShowPaymentPurchaseModal] = React.useState(false);
  const [showPaymentModalOrderId, handleShowPaymentModalOrderId] = React.useState(null);

  const handleTriggerChangeTableContent = () => {
    _handleTriggerChangeTableContent(counter + 1);
  };
  const [pending, setPending] = React.useState(true);
  const [rows, setRows] = React.useState([]);
  const [rowsOrg, setRowsOrg] = React.useState({});
  const [sponsors, setSponsors] = React.useState([]);
  const [editRow, toggleEdit] = React.useState(null);
  const [rowsFilter, setRowsFilter] = React.useState({});
  const [skipCount, setSkipCount] = React.useState(0);
  const [totalRows, setTotalRows] = React.useState(0);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [maxResultCount, setMaxResultCount] = React.useState(100);
  const [searchString, setSearchString] = React.useState('');
  const [sortString, setSortString] = React.useState('order.paid_time_utc+desc');

  const findAndReplaceRowData = (row: {}, newData: {}, isPaymentPage: string | null) => {
    if (!editRow || !newData) {
      return;
    }

    if (!isPaymentPage) {
      editRow.first_name = newData.first_name;
      editRow.last_name = newData.last_name;
      editRow.email_address = newData.email_address;
      editRow.phone_number = newData.phone_number;
      editRow.remark = newData.remark;
      editRow.sponsor_name = newData.sponsor_name;
      editRow.sponsor_id = newData.sponsor_id;
    } else {
      editRow.customer_first_name = newData.customer_first_name;
      editRow.customer_last_name = newData.customer_last_name;
      editRow.customer_email_address = newData.customer_email_address;
      editRow.customer_phone_number = newData.customer_phone_number;
    }

    // toggleEdit(editRow);
  };
  const fetchData =  async () => {
    try {
      /* eslint-disable */
      const ticketsUrl = `/api/v1/1/events/${eventId}/attendees?max_result_count=${maxResultCount}&skip_count=${skipCount}&has_voided=false&sorting=${sortString}&search_type=all${searchString ? '&search_text=' + searchString : ''}`;
      const ticketTableFilterUrl = '/api/v1/1/merchants/attendee_field_filter';
      const paymentUrl = `/api/v1/1/events/${eventId}/orders?max_result_count=${maxResultCount}&skip_count=${skipCount}&order_status=30&sorting=${sortString || 'creation_time+desc'}&search_type=all${searchString ? '&search_text=' + searchString : ''}`;

      const questionUrl = `/api/v1/1/events/${eventId}/attendees_additional?event_schedule_id=${_.get(context, 'eventDetail.schedules[0].id', 0)}&max_result_count=${maxResultCount}&skip_count=${skipCount}&sorting=${sortString || 'first_name+desc'}&search_type=all${searchString ? '&search_text=' + searchString : ''}`;
      const referralsUrl = `/api/v1/1/statistics/events/${eventId}/referrals?event_schedule_id=${_.get(context, 'eventDetail.schedules[0].id', 0)}&max_result_count=${maxResultCount}&skip_count=${skipCount}&sorting=${sortString || 'referral_user_name+desc'}&search_type=all${searchString ? '&search_text=' + searchString : ''}`;
      const demographicsUrl = `/api/v1/1/events/${eventId}/demographics?event_schedule_id=${_.get(context, 'eventDetail.schedules[0].id', 0)}&max_result_count=${maxResultCount}&skip_count=${skipCount}&sorting=${sortString || 'last_name+desc'}&search_type=all${searchString ? '&search_text=' + searchString : ''}`;

      /* eslint-enable */
      let url = '';

      switch (subViewTab) {
        case 'payments':
          url = paymentUrl;
          break;
        case 'questions':
          url = questionUrl;
          break;
        case 'referrals':
          url = referralsUrl;
          break;
        case 'demographics':
          url = demographicsUrl;
          break;
        default:
          url = ticketsUrl;
      }

      setPending(true);

      if (!subViewTab && !_.size(rowsFilter)) {
        try {
          const { result } = await GET(ticketTableFilterUrl);

          let filters = JSON.parse(defaultFilterConfig);

          if (!!_.size(result.filter_config)) {
            try {
              filters = {
                ...JSON.parse(result.filter_config)
              };
            } catch (error) {
              console.error(error);
              setPending(false);
            }
          } else {
            console.warn('Incorrect filter from API');
          }

          setRowsFilter(filters);
        } catch (e) {
          console.log(e);
          setPending(false);

          console.error('Can\'t get table filter');
        }
      }

      const { result } = await GET(url);

      let _sponsors = [];

      if (!_.size(sponsors)) {
        _sponsors = await GET(`/api/v1/1/sponsors/byevent/${eventId}`);

        setSponsors(_sponsors.result);
      }
      if (
        !subViewTab &&
        result.items.findIndex((el: {}): boolean => !el.order.paid_time_utc) > -1
      ) { // if empty paid_time_utc fields exist
        const sorted = replaceEmptyPaidTimeUTCFields(result.items);

        setRows(sorted);
      } else {
        setRows(result.items);
      }

      setTotalRows(result.total_count);
      setPending(false);
      toggleEdit(null);
    } catch (e) {
      console.log(e);
      console.error('Cant get orders');
      setPending(false);
    }
  };
  const handleSortString = (_sortStr: sting) => {
    let sortStr = _sortStr;

    if (_sortStr === 'order.paid_time_utc+asc') {
      sortStr = 'order.creation_time+asc';
    }
    if (_sortStr.includes('ticket.payment_method_additional_fee')) {
      const sortDirection = _sortStr.substring(_sortStr.indexOf('+') + 1, _sortStr.length);

      sortStr = `ticket.payment_method_additional_fee+${sortDirection},ticket.sparxo_fee+${sortDirection}`;
    }

    setSortString(sortStr);
  };
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setSkipCount(page * maxResultCount - maxResultCount);
  };

  const handleMaxResultCount = (count: number) => {
    setMaxResultCount(count);
    setSkipCount(currentPage * count - count);
  };

  const replaceEmptyPaidTimeUTCFields = (tickets: []): any => {
    const sortDirection = sortString.substring(sortString.indexOf('+') + 1, sortString.length);

    const updatedRows = tickets.map((el: {}): {} => ({
      ...el,
      order: {
        ...el.order,
        paid_time_utc: el.order.paid_time_utc
        || el.order.creation_time
      }
    }));

    if (!sortString.includes('order.paid_time_utc')) {
      return updatedRows;
    }

    const sorted = updatedRows.sort((a: {}, b: {}): number => new Date(a.order.paid_time_utc) - new Date(b.order.paid_time_utc));

     if (sortDirection === 'asc') {
       return sorted;
     }
      return sorted.reverse();
  };

  React.useEffect(() => {
    fetchData();
  }, [eventId, searchString, skipCount, maxResultCount, sortString]);

  React.useEffect(() => {
    switch (subViewTab) {
      case '':
        setSortString('order.paid_time_utc+desc');
        break;
      case 'payments':
        setSortString('creation_time+desc');
        break;
      case 'questions':
        setSortString('first_name+desc');
        break;
      case 'referrals':
        setSortString('referral_user_name+desc');
        break;
      case 'demographics':
        setSortString('last_name+desc');
        break;
      default:
        setSortString('order.paid_time_utc+desc');
        break;
    }
  }, [subViewTab]);

  const menuItems = items.map((i: {}, k: number): React.Element<'li'> => {
    return (
      <li
        key={`EventPageDetailCustomers-menuItems-${k}`}
        className={`${(subViewTab ? subViewTab.toLowerCase() : '') === i.link ? 'active' : ''}`}
        onClick={() => {
          setSkipCount(0);
          setRows([]);
        }}
      >
        <Link to={`/events/${eventId}/customers/${i.link}`}>
          {i.label}
        </Link>
      </li>
    );
  });

  return (
    <EventPageDetailCustomersContent
      menuItems={menuItems}
      subViewTab={subViewTab}
      eventId={eventId}
      handleTriggerChangeTableContent={handleTriggerChangeTableContent}
      setRowsFilter={setRowsFilter}
      counter={counter}
      rows={rows}
      rowsOrg={rowsOrg}
      setRowsOrg={setRowsOrg}
      setRows={setRows}
      totalRows={totalRows}
      currentPage={currentPage}
      handlePageChange={handlePageChange}
      maxResultCount={maxResultCount}
      setMaxResultCount={handleMaxResultCount}
      rowsFilter={rowsFilter}
      pending={pending}
      showPaymentModal={showPaymentModal}
      showPaymentPurchaseModal={showPaymentPurchaseModal}
      handleSort={handleSortString}
      handleSearch={setSearchString}
      handleShowPaymentModal={handleShowPaymentModal}
      handleShowPaymentPurchaseModal={handleShowPaymentPurchaseModal}
      handleShowPaymentModalOrderId={handleShowPaymentModalOrderId}
      editRow={editRow}
      toggleEdit={toggleEdit}
      findAndReplaceRowData={findAndReplaceRowData}
      sponsors={sponsors}
      showPaymentModalOrderId={showPaymentModalOrderId}
    />
  );
};

export default EventPageDetailCustomers;
